const requisitionType = {
  New: 1,
  Used: 2,
  Auction: 3,
};

export default requisitionType;
